import { render, staticRenderFns } from "./MergeUsersSlideOver.vue?vue&type=template&id=228c5a98"
import script from "./MergeUsersSlideOver.vue?vue&type=script&lang=js"
export * from "./MergeUsersSlideOver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports